<template>
    <div class="flex flex-col bg-gray-50 p-3">
        <h3 class="font-bold">{{ $t('orders.dispatch') }}</h3>
        <div class="flex items-center mt-2">
            <CubeIcon class="w-4 h-4 mr-2"></CubeIcon>
            <span class="font-mono">Post CH Priority</span>
        </div>
        <div v-if="code" class="flex items-center mt-2">
            <MapIcon class="w-4 h-4 mr-2"></MapIcon>
            <span class="font-mono text-left pr-1">
                <a class="text-gray-900 text-sm font-medium truncate text-left block text-cyan-600 hover:underline"
                   target="_blank"
                   :href="'https://www.post.ch/swisspost-tracking?formattedParcelCodes=' + code">{{ code }}</a>
            </span>
        </div>
        <div v-if="returnCode" class="flex items-center mt-2">
            <ArrowUturnLeftIcon class="w-4 h-4 mr-2"></ArrowUturnLeftIcon>
            <span class="font-mono text-left pr-1">
                <a class="text-gray-900 text-sm font-medium truncate text-left block text-cyan-600 hover:underline"
                   target="_blank"
                   :href="'https://www.post.ch/swisspost-tracking?formattedParcelCodes=' + returnCode">{{
                        returnCode
                    }}</a>
            </span>
        </div>
    </div>

</template>

<script>

import {ArrowUturnLeftIcon, CubeIcon, MapIcon} from "@heroicons/vue/24/outline";

export default {
    props: ['code', 'returnCode'],
    components: {
        CubeIcon,
        ArrowUturnLeftIcon,
        MapIcon
    },
}
</script>

<style scoped>

</style>
